<template>
  <div class="mainMonitor">
    <transition name="el-zoom-in-center">
      <div class="treeContain" v-show="showPage" v-loading="loading">
        <div class="tabInfo" v-if="this.safetyHelmet && this.safetyHelmet.length > 0">
          <div class="tabs">
            <div
              class="lineItem tabMid cursor"
              :class="{ lineItemHight: currentTab === 'user' }"
              @click="changeTab('user')"
            >
              {{ $t('IntelligentDevice') }}
            </div>
            <div
              class="lineItem tabRight cursor"
              :class="{ lineItemHight: currentTab === 'type' }"
              @click="changeTab('type')"
            >
              {{ $t('摄像头') }}
            </div>
          </div>
        </div>
        <div class="title" v-else>{{ $t('UserListM') }}</div>
        <!-- 查询条件 -->
        <div class="serachLine">
          <el-input :placeholder="$t('PleaseEnterUseName')" clearable v-model="query.userName"> </el-input>
          <el-button type="primary" class="serachBtn" @click="searchList" size="medium">
            {{ $t('searchM') }}
          </el-button>
        </div>
        <!-- 在线用户列表 -->
        <el-tree
          :data="listData"
          node-key="id"
          default-expand-all
          :default-expanded-keys="defaultExpandIds"
          @node-expand="handleNodeExpand"
          @node-collapse="handleNodeCollapse"
          :expand-on-click-node="false"
          @node-click="handleHelmet"
          highlight-current
          class="monitorTree"
          ref="dataConfigTree"
          :props="defaultProps"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span v-if="node.childNodes.length === 0" class="onlineIcon tree-gk3-on-night"></span>
            <el-tooltip class="item" effect="dark" :content="node.label" placement="bottom">
              <span
                class="black fz16 treefamily mb2 ml2 fw500"
                :class="[node.childNodes.length === 0 && node.data.device ? 'onlineColor' : '']"
              >
                {{ node.label }}
              </span>
            </el-tooltip>
            <span class="black fz16 treefamily mb2 ml2 fw500">
              {{ node.data.deviceName }}
            </span>
            <!-- 监控中标识 -->
            <template
              v-if="
                node.data.device &&
                  node.data.device.deviceName &&
                  listPlayVideoSerialNumber.includes(node.data.device.deviceName)
              "
            >
              <img class="marginl_auto" v-if="$store.getters.isDefaultTheme" src="../../icon/ic_jiankong.png" />
              <img class="marginl_auto" v-else src="../../icon/ic_jiankong2.png" />
            </template>
          </span>
        </el-tree>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div class="liveList" v-show="showPage">
        <div class="title">{{ $t('monitoringCenter') }}</div>
        <div class="tabLine">
          <div class="lineItem borderLeft cursor" :class="{ lineItemHight: currentIndex === 4 }" @click="changeType(4)">
            4
          </div>
          <div class="lineItem borderMid cursor" :class="{ lineItemHight: currentIndex === 6 }" @click="changeType(6)">
            6
          </div>
          <div class="broad">
            <el-tooltip class="item" effect="dark" :content="$t('broadcastOnlySent')" placement="bottom">
              <div class="open-broad" @click="showBroad" v-show="!voiceBroadcastIs">
                <img
                  class="icon_open"
                  :src="
                    require(!isDefaultTheme
                      ? '@/icon/re-new-monitor/ic_hide-m.png'
                      : '@/icon/re-new-monitor/ic_hide.png')
                  "
                  alt="打开广播"
                />
                <span class="open-title">{{ $t('OpenBroadcast') }}</span>
              </div>
            </el-tooltip>
            <transition name="moveR">
              <div class="broad-record" v-show="voiceBroadcastIs">
                <VoiceBroadcast
                  v-model="voiceBroadcastIs"
                  :listPlay="listPlayVideo"
                  @closeBroad="closeBroad"
                ></VoiceBroadcast>
              </div>
            </transition>
          </div>
        </div>
        <!-- 直播列表 -->
        <div class="help">
          <img
            class="help-icon"
            :src="require(isDefaultTheme ? '@/icon/re-new-monitor/ic_info.png' : '@/icon/re-new-monitor/help-deep.png')"
            @click="closeRealvideo"
          />
          <span>{{ $t('MonitoringVideoLiveMode') }} </span>
        </div>
        <!-- 直播列表 -->
        <ul :class="voiceBroadcastIs ? 'hide-video' : 'liveVideo'">
          <li :class="vedioStyle" v-for="item in listPlayVideo" :key="item.serialNumber">
            <!-- toolClick true:执法仪，false：管控3 用于视频工具栏是否显示 -->
            <LiveVideo ref="livechild" :device="item" @close="closeVideo" @handleVideo="handleVideo"></LiveVideo>
          </li>
        </ul>
      </div>
    </transition>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="40%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="video-title">
        <span class="title">{{ $t('InRealTimVideo') }}<span class="dotting"></span></span>
        <span class="title-tip">{{ $t('VoiceVideoCallBetween') }}</span>
        <img
          class="video-close"
          :src="isDefaultTheme ? require('@/icon/monitor/close.png') : require('@/icon/real-video/close.png')"
          @click="closeRealvideo"
        />
      </div>
      <div class="reaVideo-box">
        <Realvideo
          v-if="rtcType === 'trtc'"
          :device.sync="realVideoData"
          :currentItem="currentItem"
          :deviceName="deviceName"
          :allowClick="allowClick"
          :liveBroadcast="liveBroadcast"
          @handleClose="handleClose"
          ref="HandleRealvideo"
        ></Realvideo>
        <RealVideoSrs
          v-else-if="rtcType === 'srs'"
          :device.sync="realVideoData"
          :currentItem="currentItem"
          :deviceName="deviceName"
          :allowClick="allowClick"
          :liveBroadcast="liveBroadcast"
          @handleClose="handleClose"
          ref="HandleRealvideo"
        ></RealVideoSrs>
        <RealVideoMediasoup
          v-else-if="rtcType === 'mediasoup'"
          :device.sync="realVideoData"
          :currentItem="currentItem"
          :deviceName="deviceName"
          :allowClick="allowClick"
          :liveBroadcast="liveBroadcast"
          @handleClose="handleClose"
          ref="HandleRealvideo"
        ></RealVideoMediasoup>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findDeviceList } from '@/api/monitor'
import { warning, getSession } from '@/api/common'
import { confirmWin, deepClone } from '@/util/common'
import { setHandleHelmetOperationResponse, sendLiveUrlRequest, exitLiving, grabRecord } from '@/common/websocket/live'
import LiveVideo from '@/views/monitor/live/LiveVideo.vue'
import { errorCollection } from '@/api/dmp/dmpCollection'
import Realvideo from '@/views/monitor/index/RealVideo.vue'
import RealVideoSrs from '@/views/monitor/index/RealVideoSrs.vue'
import RealVideoMediasoup from '@/views/monitor/index/RealVideoMediasoup.vue'
import VoiceBroadcast from '@/components/voiceBroadcast/VoiceBroadcast.vue'
import store from '../../store/index'
import { mapGetters } from 'vuex'
import { getLiveUrl } from '@/common/live'
import { helmetInfo } from '@/api/log/operation'
import { deviceFind, deviceStreamGet, deviceStreamStop, streamExtend } from '@/api/live'
import { creatGK3Socket } from '@/common/websocket/index'

export default {
  data() {
    return {
      currentTab: 'user',
      showPage: false,
      currentIndex: 4,
      // 列表查询条件
      query: {
        userName: '',
        // 查询状态集合，0-离线，1-在线，2-未绑定
        statusList: [1],
        // 仅查询 智能安全帽
        specType: 1,
        // 查询 智能安全帽\执法仪\国标智能安全帽
        specTypeList: [1, 2, 3],
      },
      // 列表数据
      listData: [],
      // 播放视频设备列表
      listPlayVideo: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      userName: '',
      liveUrl: '',
      resolutionP: '',
      vedioStyle: 'fourClass',
      toolClick: false,
      timeSetInterval: null,
      // 租户点击后的loading  防止过快点击打开，视频加载不出
      loading: false,
      // 显示实时视频弹窗
      dialogVisible: false,
      // 实时视频相关
      realVideoData: {
        serialNumber: null,
        username: null,
      },
      // 当前选中的安全帽设备信息
      currentItem: null,
      allowClick: false,
      deviceName: '',
      liveBroadcast: {
        currentNode: {},
        IsLive: true,
      },
      voiceBroadcastIs: false,
      // 是否有在语音通话中
      playingWaike: false,
      // 第一个节点
      firstOuId: '',
      // 这里存放要默认展开的节点 id
      defaultExpandIds: [],
      helmetInfo: null,
      // 安全帽数据
      safetyHelmet: [],
      // 循环参数
      videoInterval: null,
      // 打开的安全帽
      listPlayVideos: [],
    }
  },
  methods: {
    // tab切换
    changeTab(index) {
      if (index) {
        this.currentTab = index
      }
      if (this.currentTab === 'type') {
        this.getdeviceFind()
        clearInterval(this.timeSetInterval)
      } else {
        this.searchList()
        this.circulate()
      }
    },
    // 安全帽列表
    getdeviceFind() {
      deviceFind().then(res => {
        if (res.state === 0) {
          this.safetyHelmet = res.data
          if (this.currentTab === 'type') {
            this.listData = res.data
          }
        }
      })
    },
    // 安全帽获取地址
    handletype(data) {
      if (data.id && !this.listPlayVideos.includes(data.deviceSn)) {
        let url = ''
          this.listPlayVideos.push(data.deviceSn)
        this.loopExecution()
        deviceStreamGet({ deviceSn: data.deviceSn }).then(res => {
          if (res.state === 0) {
            url = res.data ? getLiveUrl(res.data) : ''
            this.listPlayVideo.push({
              // 设备所有者姓名
              name: data.deviceName,
              // 设备序列号
              serialNumber: data.deviceSn,
              deviceSn: data.deviceSn,
              specType: 2,
              // 播放地址
              liveUrl: url,
              resolutionP: 0,
              userId: data.userId,
              specModel: '',
              toolClick: false,
              device: data,
              currentNode: data,
              safetyHelmet: true,
            })
          }
        })
      }
    },
    closeCirculate(val, data) {
      let index = this.listPlayVideoSerialNumber.indexOf(val.userId + '')
      if (index !== -1) {
        this.listPlayVideo.splice(index, 1)
        this.listPlayVideos = this.listPlayVideos.filter(item => item !== val.deviceSn + '')
        if (this.listPlayVideo.length === 0) {
          clearInterval(this.videoInterval)
        }
      }
    },
    loopExecution() {
      this.videoInterval = setInterval(() => {
        streamExtend(this.listPlayVideos)
      }, 10000)
    },
    // 循环展开树子节点
    addChildrenIds(data) {
      const _this = this
      if (data.children) {
        data.children.forEach(function(item) {
          if (item.id) {
            _this.handleNodeExpand(item)
          }
          if (item.children) {
            _this.addChildrenIds(item)
          }
        })
      }
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      if (data.id === this.firstOuId) {
        this.defaultExpandIds = []
        return
      }
      // 删除当前关闭的节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1)
        }
      })
      if (data.children) {
        this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
      }
    },
    // 删除树子节点
    removeChildrenIds(data) {
      const ts = this
      if (data.children) {
        data.children.forEach(function(item) {
          const index = ts.defaultExpandIds.indexOf(item.id)
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1)
          }
          if (item.id) {
            ts.removeChildrenIds(item)
          }
        })
      }
    },
    // 当有播放监控的时候才展开广播聊表
    showBroad() {
      if (this.listPlayVideo.length === 0) {
        this.$message({
          message: this.$t('openMonitoringVideoFirst') + '！',
          type: 'warning',
        })
        return
      }
      this.voiceBroadcastIs = true
    },
    closeBroad() {
      this.voiceBroadcastIs = false
    },
    // 关闭实时视频
    closeRealvideo() {
      this.$refs.HandleRealvideo.close()
      this.dialogVisible = false
    },
    // 开启实时视频模式
    handleVideo(data) {
      if (this.$store.state.openRealeVideo) {
        this.$message({
          message: '请先关闭实时视频',
          type: 'warning',
        })
        return
      }
      this.closeVideo(data.device.serialNumber)
      this.dialogVisible = true
      this.realVideoData = {
        serialNumber: data.device.serialNumber,
        username: data.name,
      }

      this.currentItem = data.device
      this.deviceName = data.device.deviceName
      this.liveBroadcast.currentNode = data
      this.allowClick = data.device.specType === 1 ? false : true
    },
    // 关闭实时视频弹窗
    handleClose() {
      this.dialogVisible = false
      setTimeout(() => {
        if (!this.listPlayVideoSerialNumber.includes(this.liveBroadcast.currentNode.serialNumber)) {
          sendLiveUrlRequest(this.liveBroadcast.currentNode.serialNumber, 0)
          this.listPlayVideo.push({
            // 设备所有者姓名
            name: this.liveBroadcast.currentNode.name,
            // 设备序列号
            serialNumber: this.liveBroadcast.currentNode.serialNumber,
            // 播放地址
            liveUrl: null,
            resolutionP: 0,
            userId: this.liveBroadcast.currentNode.userId,
            specModel: this.liveBroadcast.currentNode.specModel,
            toolClick: this.toolClick,
            device: this.currentItem,
            currentNode: this.liveBroadcast.currentNode,
          })
        }
      }, 1500)
      this.realVideoData = {
        serialNumber: null,
        username: null,
      }
      // 重定义消息响应事件
      setHandleHelmetOperationResponse(this.handleHelmetOperationResponse)
    },
    // 查询列表数据
    searchList() {
      findDeviceList(this.query).then(res => {
        if (res.state === 0 && res.data[0]) {
          this.listData = res.data
          this.firstOuId = res.data[0].id
          if (this.defaultExpandIds.indexOf(this.firstOuId) === -1) {
            this.defaultExpandIds.push(this.firstOuId)
          }
        } else {
          this.listData = []
        }
      })
    },
    getHasVideo() {
      if (this.listPlayVideo && this.listPlayVideo.length > 0) {
        for (let i = 0; i < this.listPlayVideo.length; i++) {
          let param = deepClone(this.query)
          param.userName = this.listPlayVideo[i].name
          findDeviceList(param).then(res => {
            if (!res.data[0]) {
              exitLiving(this.listPlayVideo[i].serialNumber)
              // this.changeList()
              this.listPlayVideo.splice(i, 1)
              // 若没有视频在播放  关闭广播
              if (this.listPlayVideo.length === 0) {
                this.closeBroad()
                this.$store.commit('openVedio', false)
              }
            }
          })
        }
      }
    },
    handleWaikeHelmet(value) {
      this.playingWaike = false
      let waikeHelmet = []
      if (this.showWaike && this.waikIngInfo && this.waikIngInfo.userList) {
        for (let item of this.waikIngInfo.userList) {
          waikeHelmet.push(item.helmetId)
        }
        // 判断当前点击查看直播的是否在语音通话
        if (waikeHelmet.indexOf(value.device.serialNumber) !== -1) {
          this.playingWaike = true
          return
        }
      }
    },
    handleHelmet(val) {
      if (this.currentTab === 'type') {
        this.handletype(val)
      } else {
        if (!val.userId) {
          return
        }
        helmetInfo(val.userId).then(res => {
          if (res.state === 0 && res.value) {
            if (res.value && res.value.pattern && res.value.pattern === 3) {
              warning(this.$t('patternMode'))
              return
            } else {
              creatGK3Socket()
              this.handleNodeClick(val)
            }
          }
        })
      }
    },

    // 机构树点击事件
    async handleNodeClick(data) {
      console.log(data, this.currentIndex)

      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 1000)

      await this.handleWaikeHelmet(data)
      if (this.playingWaike) {
        warning(this.$t('deviceInVoiceCall'))
        return
      }
      // 点击节点 为设备并且不在播放列表
      if (
        data.device &&
        data.device.serialNumber &&
        !this.listPlayVideoSerialNumber.includes(data.device.serialNumber)
      ) {
        // 为频繁关闭打开做延迟处理
        setTimeout(() => {
          sendLiveUrlRequest(data.device.serialNumber, 0)
        }, 1000)
        this.toolClick = data.device.specType === 2 ? true : false
        this.listPlayVideo.push({
          // 设备所有者姓名
          name: data.name,
          // 设备序列号
          serialNumber: data.device.serialNumber,
          specType: data.device.specType,
          // 播放地址
          liveUrl: null,
          resolutionP: 0,
          userId: data.userId,
          specModel: data.device.specModel,
          toolClick: this.toolClick,
          device: data.device,
          currentNode: data,
        })
        this.$store.commit('openVedio', true)
      }
    },
    changeList() {
      // 视频长度作为改变 vedio class =>用于改变 box： width height
      if (this.listPlayVideo.length <= 4) {
        this.vedioStyle = 'fourClass'
      } else if (this.listPlayVideo.length >= 4) {
        this.vedioStyle = 'sixClass'
      }
    },
    // 自定义处理获取到直播链接事件
    handleLiveUrlResponse(serialNumber, liveUrl, resolutionP) {
      liveUrl = getLiveUrl(liveUrl)
      let index = this.listPlayVideoSerialNumber.indexOf(serialNumber)
      if (serialNumber && index !== -1) {
        let playVideo = this.listPlayVideo[index]
        playVideo.liveUrl = liveUrl
        playVideo.resolutionP = resolutionP
        this.$set(this.listPlayVideo, index, playVideo)
      }
    },

    // 关闭直播视频
    closeVideo(serialNumber, item) {
      if (this.currentTab === 'type') {
        this.closeCirculate(item)
      } else {
        let index = this.listPlayVideoSerialNumber.indexOf(serialNumber)
        if (serialNumber && index !== -1) {
          this.listPlayVideo.splice(index, 1)
          if (this.listPlayVideo.length === 0) {
            this.closeBroad()
            this.$store.commit('openVedio', false)
          }
        }
        exitLiving(serialNumber)
      }
    },
    // 直播时处理websocket响应
    handleHelmetOperationResponse(params) {
      console.log(params)
      // action:0=加入，1=离开，2=切换分辨率，3=直播进入，4=直播停止
      // {"action":1,"camera":0,"gps":0,"laser":0,"led":0,"readdingLamp":0,"rfid":0,"warnningLamp":0}
      // {"action":0,"ihVersion":"21","isAgoraSpeech":false,"isAudioRecord":false,"isFaceScan":false,"isQRScan":false,"isRecord":false,"isRecordVoiceOpen":true,"isSwitchUser":false,"isWebRtcConnect":false,"netWorkState":1,"roomId":0}
      // {"action": 2,"enterResult":false}
      // {"cloudRoomType":"3","channelId":"H-100-001","status":"{\"action\":3,\"startLiveResult\":true,\"liveUrl\":\"http:xxxx\",\"errorMsgType\":0,\"roomId\":12345}"}
      var status = JSON.parse(params.status)
      console.log(`头盔：${params.helmetId} 状态：${status}`)
      // 通过头盔id获取到对应的用户名
      let name = null
      let userId = null
      let helmetIndex = this.listPlayVideoSerialNumber.indexOf(params.helmetId)
      if (helmetIndex === -1) {
        // 非播放中头盔信息，直接返回
        return
      } else {
        // 当前请求头盔id对应的用户名
        name = this.listPlayVideo[helmetIndex].name
        userId = this.listPlayVideo[helmetIndex].userId
      }
      if (status.action === 2) {
        // 头盔加入房间失败
        if (!status.enterResult) {
          console.error(name + this.$t('helmetVideoConnectionFailed'))
          errorCollection('实时监控', '安全帽视频连接', {
            status: 200,
            data: { state: -1, msg: '安全帽视频连接失败，请重新连接' },
          })
        }
        return
      }

      if (status.action === 1) {
        console.log(`拍照状态:${status.camera}`)
        return
      }

      if (status.isFaceScan) {
        warning(name + this.$t('FaceRecognitionProgress'))
        return
      }
      if (status.isQRScan) {
        warning(name + this.$t('helmetScanningQR'))
        return
      }
      if (status.isSwitchUser) {
        warning(name + this.$t('SwitchingUsers'))
        return
      }
      if (status.isAgoraSpeech) {
        warning(name + this.$t('MicrophoneOccupied'))
        return
      }
      if (status.isRecord) {
        confirmWin(
          name + this.$t('RecordingPreemptOrNot') + '？',
          () => {
            grabRecord(params.helmetId)
          },
          () => {
            // 点击取消事件 关闭直播框
            this.closeVideo(params.helmetId)
          }
        )
        return
      }
      // 开始直播或者直播切换分辨率
      if (status.action === 3) {
        if (status.errorMsgType === 1) {
          this.realVideoSeize(params.helmetId, name, userId, status)
        } else if (status.errorMsgType === 2) {
          warning(name + '打开摄像头失败，请重试！')
        } else if (status.liveUrl) {
          this.$nextTick(() => {
            this.$refs.livechild[helmetIndex].changeReaolution(status.resolution)
          })

          if (this.$store.state.isUserSend) {
            // 延时防止快速点击多个直播时不触发直播链接
            setTimeout(() => {
              this.$store.commit('userSend', false)
              this.handleLiveUrlResponse(params.helmetId, status.liveUrl, status.resolution)
            }, 1000)
          }
        }
      }
      //当直播被会议抢占时，退出关闭视频窗口，弹窗提示
      if (status.action === 4) {
        if (status.stopEventType === 1) {
          // 视频会议抢占导致直播停止
          console.log('视频会议抢占导致直播停止', params.helmetId, name, status.userId)
          this.realVideoSeize(params.helmetId, name, userId, status)
          this.$refs.livechild[helmetIndex].clearSetTimeout()
        } else if (status.stopEventType === 0) {
          // 正常停止直播
          console.log('正常停止直播')
        }
      }
    },
    // 实时视频抢占
    realVideoSeize(helmetId, name, userId, status) {
      if (this.$store.state.openRealeVideo && this.$store.state.videoInfo.serialNumber === helmetId) {
        this.$message({
          message: '该设备正在进行实时视频',
          type: 'warning',
        })
        // 点击取消事件 关闭直播框
        this.closeVideo(helmetId)
        this.voiceBroadcastIs = false
        return
      }
      console.log('statusInfo', status)
      confirmWin(
        name + this.$t('WhetherToJump') + '？',
        () => {
          // 点击确认事件 跳转至首页开启实时视频
          let helpInfo = {
            serialNumber: helmetId,
            username: name,
            userId: userId,
            showTool: this.toolClick,
            statusInfo: status,
          }
          this.$store.commit('changeHelpInfo', helpInfo)
          this.$store.commit('currentIndex', 'command')
          this.$router.push({
            path: '/newIndex/newCommand',
          })
          this.voiceBroadcastIs = false
        },
        () => {
          // 点击取消事件 关闭直播框
          this.closeVideo(helmetId)
          this.voiceBroadcastIs = false
        }
      )
    },
    changeType(num) {
      this.currentIndex = num
      if (num === 4) {
        this.vedioStyle = 'fourClass'
      } else {
        this.vedioStyle = 'sixClass'
      }
    },
    circulate() {
      this.timeSetInterval = setInterval(() => {
        if (getSession('access_token')) {
          this.searchList()
          this.getHasVideo()
        }
      }, 20000)
    },
  },
  computed: {
    ...mapGetters(['isCloud', 'rtcType', 'isDefaultTheme']),
    // 播放视频序列号集合
    listPlayVideoSerialNumber() {
      return this.listPlayVideo.map(item => {
        return item.serialNumber
      })
    },
    // 语音通话中监听
    waikIngInfo() {
      return this.$store.state.waikeInfo
    },
    // 语音通话中监听
    showWaike() {
      return this.$store.state.openWaike
    },
  },
  watch: {},
  components: {
    LiveVideo,
    Realvideo,
    RealVideoSrs,
    RealVideoMediasoup,
    VoiceBroadcast,
  },
  mounted() {
    this.getdeviceFind()
    clearInterval(this.videoInterval)
    this.showPage = true
    this.searchList()
    // 自定义消息响应处理
    setHandleHelmetOperationResponse(this.handleHelmetOperationResponse)
    this.circulate()
  },
  beforeDestroy() {
    if (this.listPlayVideo && this.listPlayVideo.length > 0) {
      for (let item of this.listPlayVideo) {
        this.closeVideo(item.serialNumber)
      }
    }
    // 退出后清空消息响应处理
    setHandleHelmetOperationResponse(() => {})
    clearInterval(this.timeSetInterval)
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/playing.styl'
.mainMonitor
  background #EEF5FE
  margin: 0!important;
  height 100%!important
  .treeContain
    width 17%
    height 95%
    margin-left: 20px;
    margin-top: 20px;
    pointer-events: auto
    background #fff
    border-radius: 4px;
    .tabInfo
      padding-top: 15px
      margin: 0 10px
      .tabs
        display flex
        justify-content: center
        width 90%
        height: 36px;
        line-height: 32px;
        margin: 0 auto
        border-radius: 6px
        color: #2372df
        box-sizing: border-box
      .lineItem
        font-weight: bold;
        text-align: center
        width: 50%;
        box-sizing: border-box
      .lineItemHight
        background: #0e65dd
        color #fff
      .tabMid
        border-top: 2px solid var(--boredr-color);
        border-left: 2px solid var(--boredr-color);
        border-bottom: 2px solid var(--boredr-color);
      .tabRight
        border-top: 2px solid var(--boredr-color);
        border-right: 2px solid var(--boredr-color);
        border-bottom: 2px solid var(--boredr-color);
    /deep/.el-tree-node__label
      font-size 16px
    .title
      padding-top: 2px;
      font-size: 18px;
      font-weight: bold;
      color: var(--title-color)
      line-height: 32px;/*no*/
      bg-image('~@/icon/re-new-monitor/img_head.png')
      padding-left: 62px;
      .voice-broadcast-but2
        margin-left: 55px;
        padding: 6px 10px 5px 10px;
        position: relative;
        top: 5px;
        img
          vertical-align: middle
          height: 16px
          margin-right: 5px
    .serachLine
      margin 20px 10px 10px 10px
      display flex
      align-items center
      justify-content center
      /deep/.el-input__inner
        color: #222
        height 36px;/*no*/
        line-height: 36px;/*no*/
      .serachBtn
        margin-left: 5px;
        line-height: 20px;
      >>>.el-button--medium
        padding 7px 20px
    .monitorTree
      overflow auto
      height calc(100% - 110px)
      background-color transparent !important
      margin-top 10px
      .onlineIcon
        display inline-block
        width 20px
        height 20px
      .tree-gk3-on-night
        bg-image('~@/icon/re-new-monitor/tree-gk3-on-night.png')
  .help
    display flex
    align-items: center
    font-size 15px
    vertical-align: middle
    margin-left: 190px;
    position: absolute;
    color var(--text-color)
    line-height: 46px
    opacity 0.5
    .help-icon
      width 16px
      height 16px
      margin-right 5px
  .liveList
    width 80%
    height 95%
    position: absolute;
    top: 0px;
    right: 20px;
    margin-left: 20px;
    margin-top: 20px;
    pointer-events: auto
    background #fff

    .title
      position: absolute;
      top: 0px;
      left: 0px;
      font-size: 18px;
      font-weight: bold;
      color: var(--title-color)
      line-height: 46px;/*no*/
      padding-left: 86px;
      width: 85%;
      bg-image('~@/icon/re-new-monitor/img_head2.png')

    .tabLine
      position absolute
      top: 6px;
      right: 24px;
      height 95%
      display flex
      .lineItem
        font-weight: bold;
        line-height: 30px
        text-align: center
        width: 40px;
        height: 30px;
        opacity: 0.7;
        color var(--color-bg-black)
      .lineItemHight
        background: var(--new-tab-bg-heighlight)
        opacity: 1;
        color var(--color-bg-black-heiglight)
      .borderLeft
        border-top: 2px solid var(--boredr-color);
        border-left: 2px solid var(--boredr-color);
        border-bottom: 2px solid var(--boredr-color);
      .borderMid
        border-top: 2px solid var(--boredr-color);
        border-left: 2px solid var(--boredr-color);
        border-bottom: 2px solid var(--boredr-color);
    .borderRight
      border-top: 2px solid var(--boredr-color);
      border-right: 2px solid var(--boredr-color);
      border-bottom: 2px solid var(--boredr-color);
    .liveVideo
      width: 97%;
      height: 89%;
      margin-top: 62px;
      margin-left: 33px;
      overflow-y: auto;
      li
        border: 1px solid #0BFCFF;
        border-radius: 2px;
        margin: 5px
      .fourClass
        width 49%
        height 48%
        box-sizing border-box
        float left
      .sixClass
        width: 32.3%;
        height: 48%;
        box-sizing border-box
        float left
    .hide-video
      width calc(100% - 450px);
      height: 89%;
      margin-top: 63px;
      margin-left: 33px;
      overflow-y: auto;
      li
        border: 1px solid #0BFCFF;
        border-radius: 2px;
        margin: 5px
      .fourClass
        width 49%
        height 48%
        box-sizing border-box
        float left
      .sixClass
        width 48.3%
        height 32%
        box-sizing border-box
        float left
  >>>.el-loading-mask
    opacity 0.1
.el-main
  position relative
.broad
  height 99%
  margin-left 15px
  .open-broad
    display flex
    align-items: center
    float right
    width 90px;/*no*/
    border-radius: 2px;
    padding 6px 10px
    cursor pointer
  .icon_open
    width 20px
    height 20px
    margin-right: 6px
  .broad-record
    width 390px
    height 100%
    border-radius: 4px
    border: 1px solid #DCDCDC;
.video-title
  position relative
  height: 44px
  line-height: 44px
  .title
    font-size: 18px
    margin 0 10px
  .title-tip
    height: 26px
    line-height: 26px
    display inline-block
    border-radius: 13px
    padding 0 14px
  .video-close
    float right
    width 17px
    height 17px
    margin-top 16px
    cursor pointer
.editBtn
  display none
  .addicon
    margin-right 10%
    width 30px;/*no*/
    height 30px;/*no*/
.reaVideo-box
  width 100%
  height 420px
.open-all
  padding 2px 5px
  border 1px solid #0bfcff
  margin-left: 10px
  border-radius 2px
  font-size 12px
  color #0bfcff
  margin 4px 14px
  cursor pointer
.custom-tree-node
  flex 1
  display flex
  align-items center
  justify-content flex-start
  padding-right 20px
  width 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  .node-txt
    font-size 16px;/*no*/
  .marginl_auto
    margin-left auto
.el-tree-node__content:hover .editBtn
    display block
>>>.el-dialog__header
  padding 0
>>>.el-dialog__body
  height: 465px
  padding 0 10px 10px
  overflow-y visible
>>>.v-modal
  z-index 100!important
.test
  background: #ccc
  pointer-events: auto
#voice-broadcast-but
  width: 80px;
  height: 80px;
  background: var(--search-btn-bg);
  border: 1px solid rgb(15, 192, 245);
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 40px;
  position: absolute;
  left: 226px;
  bottom: 46px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  img
    padding-top: 13px
  span
    font-size: 14px;
    font-weight: 400;
    color: var(--search-btn-color);
    line-height: 18px;
.open-title
  color var(--title-color);
// 深色模式样式覆盖
.theme-dark
  .mainMonitor
    background #001143
    .treeContain
      background #002086
      .monitorTree
        .tree-gk3-on-night
          bg-image('~@/icon/re-new-monitor/tree-gk3-on-night-m.png')

      .title
        bg-image('~@/icon/re-new-monitor/img_head2-m.png')
    .liveList
      background #002086
      .title
        bg-image('~@/icon/re-new-monitor/img_head-m.png')
  .broad
    .broad-record
      border: 0.00520833rem solid #295AFF;
</style>
